const token = localStorage.getItem('token') || '';
import env from "../enviroments/enviroment"

const downloadVideo = (group) => {
    return fetch(`${env.base_url}/videos/?videoGroup=${group}`,{
        headers: {
            Authorization: `Bearer ${token}`,
        }
    })
}

export default downloadVideo;